var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#0078E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5175 15.8574L13.6602 19.7148L14.6677 20.7223L16.8051 18.585V25.6637H18.23V18.585L20.3673 20.7223L21.3749 19.7148L17.5175 15.8574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2157 15.5666C23.1314 12.4575 20.5761 9.9541 17.447 9.9541C16.0096 9.9541 14.6323 10.4859 13.5688 11.4515C12.6525 12.2835 12.0333 13.3773 11.7909 14.5756C10.9246 14.7619 10.1339 15.21 9.52217 15.8695C8.77485 16.6752 8.36328 17.7246 8.36328 18.8241C8.36328 21.2204 10.3129 23.17 12.7092 23.17C12.7149 23.17 12.7205 23.1699 12.7246 23.1699H13.4573V21.745H12.7187L12.7051 21.7451C11.0964 21.7429 9.78818 20.4334 9.78818 18.8241C9.78818 17.312 10.9671 16.0331 12.4722 15.9126L13.0635 15.8653L13.1241 15.2752C13.352 13.054 15.2105 11.379 17.447 11.379C19.8434 11.379 21.793 13.3285 21.793 15.7249V16.9717H22.826C24.142 16.9717 25.2127 18.0424 25.2127 19.3584C25.2127 20.6744 24.142 21.7451 22.826 21.7451L21.5792 21.7448V23.1698H22.8028C22.8105 23.1699 22.8182 23.1701 22.826 23.1701C24.9278 23.1701 26.6376 21.4602 26.6376 19.3584C26.6376 17.3882 25.1352 15.7623 23.2157 15.5666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2743,
    height: 18.2743,
    fill: "white",
    transform: "translate(8.36328 8.67188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMapping);
export default __webpack_public_path__ + "static/media/upload_mapping.3da799ee3e5320e7bc872d9d71e68df8.svg";
export { ForwardRef as ReactComponent };